import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router, RouterLink} from '@angular/router';
import {CheckInSignatureComponent} from '../check-in-signature/check-in-signature.component';
import {InfoPageHeaderComponent} from '../../shared/components/info-page-header/info-page-header.component';
import {SignaturePadComponent} from '../../shared/components/signature-pad/signature-pad.component';
import {ContractTypeService} from '../../core/api/contract-type.service';
import {HoomvipStorage} from '../../core/hoomvip-storage/hoomvip-storage.service';
import {SignatureService} from '../../core/api/signature.service';
import {ModalErrorService} from '../../core/services/modal-error.service';
import {CheckInService} from '../../core/api/check-in.service';
import {FamilyRelationshipService} from '../../core/api/family-relationship.service';
import {
  FamilyRelationship,
  FamilyRelationshipType
} from '../../shared/models/family-relationships.model';
import {MetricsService} from '../../core/services/metrics.service';
import {GlobalErrorService} from '../../core/services/global-error.service';
import {Observable, of} from 'rxjs';
import {ReservationService} from '../../core/api/reservation.service';

export type Familiar =
  {
    id: number;
    nombreCompleto: string;
  };

@Component({
  selector: 'app-check-in-signature-minor',
  templateUrl: './check-in-signature-minor.component.html',
  styleUrls: ['./check-in-signature-minor.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, InfoPageHeaderComponent, SignaturePadComponent, RouterLink],
})
export class CheckInSignatureMinorComponent extends CheckInSignatureComponent implements OnInit {
  protected familyRelationshipTypes: FamilyRelationshipType[] | undefined | null;
  protected adultosResponsables: Familiar[] | undefined | null;
  protected menores: Familiar[] | undefined | null;


  constructor(
    fb: FormBuilder,
    router: Router,
    contractTypeService: ContractTypeService,
    hoomvipStorage: HoomvipStorage,
    signatureService: SignatureService,
    modalErrorService: ModalErrorService,
    private globalErrorService: GlobalErrorService,
    private checkInService: CheckInService,
    private familyRelationshipService: FamilyRelationshipService,
    override metricsService: MetricsService,
    reservationService: ReservationService,
  ) {
    super(fb, router, contractTypeService, hoomvipStorage, signatureService, modalErrorService, metricsService, reservationService);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.form.addControl('menor', this.fb.control('', Validators.required));
    this.form.addControl('parentesco', this.fb.control('', Validators.required));
    this.form.addControl('adultoResponsable', this.fb.control('', Validators.required));
    this.form.get('aceptaPrivacidad')?.setValue(false);
    this.form.removeControl('aceptaCondiciones');

    this.getFamilyRelationshipTypes();
    this.getAdultsAndChildren();
  }

  protected override shouldRequireContractRead(): Observable<boolean> {
    return of(false);
  }

  private getFamilyRelationshipTypes() {
    this.familyRelationshipService.getFamilyRelationshipTypes().subscribe({
      next: (types) => {
        this.familyRelationshipTypes = types.family_relationships;
      },
      error: (error) => {
        console.error('Error fetching family relationship types:', error);
        this.familyRelationshipTypes = null;
      }
    });
  }

  public getAdultsAndChildren() {
    this.checkInService.getCheckInsWithChildren().subscribe({
      next: (checkIns) => {
        this.adultosResponsables = checkIns.adults.map((checkIn) => ({
          id: checkIn.id,
          nombreCompleto: `${checkIn.NAME} ${checkIn.SURNAME}`,
        }));
        if (this.adultosResponsables.length === 1) {
          this.form.get('adultoResponsable')?.setValue(this.adultosResponsables[0].id);
        }
        this.menores = checkIns.children.map((checkIn) => ({
          id: checkIn.id,
          nombreCompleto: `${checkIn.NAME} ${checkIn.SURNAME}`,
        }));
        if (this.menores.length === 1) {
          this.form.get('menor')?.setValue(this.menores[0].id);
        }
      },
      error: (error) => {
        console.error('Error fetching check-ins with children:', error);
        this.adultosResponsables = [];
        this.menores = [];
      }
    });
    }

  override onSubmit(): void {
    if(!this.validateSubmit()) {
      return;
    }
    this.loading.set(true);
    this.familyRelationshipService.saveFamilyRelationships(this.buildFamilyRelationship()).subscribe({
      next: () => {
        this.metricsService.checkInMinorRelation();
        super.onSubmit();
      },
      error: (error) => {
        this.globalErrorService.markHandled(error);
        console.error('Error saving family relationships:', error);
        this.modalErrorService.open(
          'Error al guardar parentesco',
          this.modalErrorService.extractMessages(error)
        );
        this.loading.set(false);
      }
    });
  }

  private buildFamilyRelationship(): FamilyRelationship {
    const formValue = this.form.getRawValue();
    return {
      child_relationship_type_id: formValue.parentesco,
      adult_checkin_id: Number.parseInt(formValue.adultoResponsable),
      child_checkin_id: Number.parseInt(formValue.menor),
    };
  }

  protected override checkInEnd(signatureResponse: any) {
    console.log('Firma guardada correctamente', signatureResponse);
    this.hoomvipStorage.setSignatureInfo(signatureResponse.contractUrl, signatureResponse.travelRegisterFileURL);
    this.router.navigate(['/check-in-minor-end'], {
      state: {
        isMinor: true,
        contractUrl: signatureResponse.contractUrl,
        travelRegisterFileURL: signatureResponse.travelRegisterFileURL
      }
    });
  }
}
